import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { BenefitsBento } from '../components/BenefitsBento';
import { NarrativeSection } from '../components/NarrativeSection';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { ClosingCTA } from '../components/ClosingCTA';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { TwelveTabProblem } from '../components/TwelveTabProblem';
import { LivesInSlack } from '../components/LivesInSlack';

// The AI co worker page (/ai-coworker). One argument, told once: here is what
// Giga does, here is the tab tax it removes, here is the mention that removes
// it, and here is what stands behind the answer. The four-pillar platform tour
// lives on the platform home page instead.
export function Home() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-11018" data-mp="3ow42tnp584s4" />
      {/* "What Giga can do" overview — the bento leads the page right after the
       hero so cold ad/UGC traffic gets the answer ("what is this, and it
       actually does the work") before anything else. */}
      <BenefitsBento data-id="element-11019" data-mp="2vvltoav6nw2b" />
      {/* Problem statement as a CONTRAST beat — "the world without Giga" (11
       tabs / context-switch tax). Leading with the answer, not the problem, is
       intentional for traffic that arrives pre-sold on the pain. */}
      <TwelveTabProblem data-id="element-11020" data-mp="2hy75f9go1ubx" />

      {/* The single product beat this page needs: the mention, in the surface
       people already have open. The four-pillar platform tour (connections
       map, company brain, co-worker surfaces, workspace primitives) belongs on
       the platform home page — here it buried the one idea an AI co worker
       page is selling. */}
      <LivesInSlack data-id="element-11021" data-mp="1z7fui3h15vvf" />

      {/* Setup, then who it is for. */}
      <GettingStartedSteps data-id="element-11022" data-mp="1z6mmkz6c50bp" />
      <AudienceSwitch data-id="element-11023" data-mp="1u8cqmmcsdvp1" />

      {/* Finale energy ramp: calm cream social proof (WallOfLove) → bold orange
       founder conviction (NarrativeSection) → dark confident close. */}
      <WallOfLove data-id="element-11024" data-mp="1kmtncsbelnwx" />
      <NarrativeSection data-id="element-11025" data-mp="1omc6pjnktqxn" />
      <ClosingCTA data-id="element-11026" data-mp="1omu2yga8o55k" />
    </>;
}